import React from 'react';
import { MessageCircle } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${restaurantInfo.whatsapp}?text=Merhaba, sipariş vermek istiyorum.`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 shadow-lg hover:bg-[#128C7E] transition-all duration-300 hover:scale-110 animate-pulse-gentle"
      aria-label="WhatsApp ile sipariş ver"
    >
      <MessageCircle size={28} />
      <span className="absolute -top-2 -right-2 bg-[#722F37] text-white text-xs px-2 py-1 rounded-full">
        Sipariş
      </span>
    </a>
  );
};

export default WhatsAppButton;